import {
  Cosmetic,
  ColorOption,
  ColorGrade,
  CreateCosmetic,
  SingleReview,
} from "../models/Cosmetic";
import { axiosWrapper } from "../clients/axiosWrapper";
import { SortBy } from "../enums/SortTypeEnum";
const getSingleReviews = async (cos: Cosmetic[]): Promise<SingleReview[]> => {
  var sorted: SingleReview[] = [];
  cos.map((cosmetic: Cosmetic) =>
    cosmetic.colors.map((color: ColorOption) =>
      color.grades.map((grade: ColorGrade, ig: number) =>
        sorted.push({
          guid: cosmetic.guid,
          userName: grade.username,
          name: cosmetic.name,
          brand: cosmetic.brand,
          category: cosmetic.category,
          type: cosmetic.type,
          color: color.name,
          grade: grade.grade,
          comment: grade.comment,
          createDate: grade.createDate,
        })
      )
    )
  );
  return sorted;
};

const getFilteredCosmetics = async (
  sortBy: SortBy,
  page: number,
  pickedCategory: string | undefined,
  pickedType: string | undefined,
  filter?: string
): Promise<Cosmetic[]> => {
  const url = "cosmetics";
  const model = {
    search: filter,
    sortBy,
    page,
    category: pickedCategory,
    type: pickedType,
  };
  return await axiosWrapper.getWithBody(url, model);
};

const getCosmetic = async (guid: string): Promise<Cosmetic> => {
  return await axiosWrapper.get(`cosmetics/${guid}`);
};

const addReview = async (newReview: CreateCosmetic): Promise<Cosmetic> => {
  return await axiosWrapper.post("cosmetics", newReview);
};

const addLike = async (guid: string): Promise<void> =>
  await axiosWrapper.post("cosmetics/like", guid);

const addDisike = async (guid: string): Promise<void> =>
  await axiosWrapper.post("cosmetics/dislike", guid);

const addBag = async (guid: string): Promise<void> =>
  await axiosWrapper.post("cosmetics/bag", guid);

const updateReviewComment = async (
  guid: string,
  color: string,
  updatedComment: string
): Promise<Cosmetic> =>
  await axiosWrapper.put(`cosmetics/review/${guid}/${color}`, updatedComment);

const updateDescription = async (
  guid: string,
  description: string
): Promise<void> =>
  await axiosWrapper.put(`cosmetics/${guid}/description`, description);

export const cosmeticService = {
  addReview,
  getSingleReviews,
  getFilteredCosmetics,
  getCosmetic,
  addLike,
  addDisike,
  addBag,
  updateReviewComment,
  updateDescription,
};
